import { DrawerComponent } from '../initializers/drawer-component';
import clsx from 'clsx';
import { useLayout } from 'layouts/core/layout.context';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import { WithChildren } from 'ts-types';

const Content: FC<WithChildren> = ({ children }) => {
  const { classes, customClassName } = useLayout();
  const location = useLocation();
  useEffect(() => {
    DrawerComponent.hideAll();
  }, [location]);

  return (
    <div id="kt_content_container" className={clsx(classes.contentContainer.join(' '), customClassName)}>
      {children}
    </div>
  );
};

export { Content };
